import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GLOBALS from '../services/GLOBALS';

const OnboardingRedirect = ({ children }) => {
  const history = useHistory();
  const userRoles = useSelector((state) => state.userRole?.data || []);
  
  useEffect(() => {
    // Check if user has USER_MANAGER role
    const isUserManager = userRoles.some(role => 
      role.role_name === GLOBALS.ROLES.USER_MANAGER
    );
    
    if (isUserManager) {
      // Check if user has completed onboarding (you can add this check based on your backend logic)
      const hasCompletedOnboarding = sessionStorage.getItem('onboarding_completed');
      
      if (!hasCompletedOnboarding) {
        // Redirect to unified onboarding
        history.push('/onboarding/unified');
        return;
      }
    }
  }, [userRoles, history]);

  return children;
};

export default OnboardingRedirect;
